import React from 'react'
import styles from './no-pupils.styles'
import injectSheet from 'react-jss'
import noPupils from './no-pupils.png'
import { Link } from 'react-router-dom'

const NoPupils = ({ classes }) => (
  <div className={classes.container}>
    <h2>No pupils yet</h2>
    <img src={noPupils} alt="There are no pupils yet" />
    <p>
      <Link to="/add-pupils">Let's add some pupils</Link>
    </p>
  </div>
)

export default injectSheet(styles)(NoPupils)
